<template>
  <div class="borrow-list-item"
       :data-sensors-exposure-property-product_code="item.configId"
       data-sensors-exposure-property-element_positon="product_list"
       data-sensors-exposure-property-product_type="diversion"
       data-sensors-exposure-event-name="Diversion_Exposure" 
  >
    <div class="item" >
      <div class="top">
        <div class="top-left">
          <img :src="item.icon" />
          <span class="top-left-more">{{ item.productName }}</span>
          <div
            class="top-left-border"
            v-for="(item, index) in dealWorld(item.cornerWord)"
            :key="index"
          >
            {{ item }}
          </div>
        </div>
        <div class="top-right" v-if="showLoanCounts && item.loanCounts">
          <span class="bg-red">{{ item.loanCounts }}</span>人已借款
        </div>
      </div>
      <div class="bottom">
        <div class="configLimit">
          <div class="bottom-left-limit">额度高达 (元)</div>
          <div class="flex-center">
            <div class="bottom-left-money">
              {{ item.configLimit | currency }}
            </div>
          </div>
        </div>
        <div class="minPrice">
          <div class="bottom-left-label">
            <span>年化利率</span>
            <p>{{ item.minPrice }}%-{{ item.maxPrice }}%</p>
            <!-- <span>期限{{ item.minTerms }}-{{ item.terms }}个月</span> -->
          </div>
        </div>
        <div class="bottom-right" @click.stop="$emit('on-borrow')">{{ item.buttonName }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      default: () => ({})
    },
    showLoanCounts: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {}
  },
  methods: {
    // 处理标签
    dealWorld (cornerWord = '') {
      if (cornerWord) {
        return cornerWord.split(',')
      }
      return []
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../assets/less/mixin.less";

.borrow-list-item {
  background: #ffffff;
  padding:0 20px 20px 20px;
  height: 220px;
  position: relative;
  &:after {
    border-bottom: 1px solid #E0E0E0;
    width: calc(100% - 40px);
    content: '';
    position: absolute;
    bottom: 0;
  }
  .bg-red{color:#ff4633}
  .top {
    height: 100px;

    display: flex;
    align-items: center;
    justify-content: space-between;
    &-left {
      display: flex;
      justify-content: space-between;
      align-items: center;
      &-more {
        margin-left: 14px;
        font-size: 28px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #333333;
        max-width: 250px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
      > img {
        width: 48px;
        height: 48px;
        border-radius: 10px;
      }
      &-border {
        margin-left: 10px;
        margin-right: 5px;
        max-width: 200px;
        line-height: 34px;
        text-align: center;
        border-radius: 4px;
        border: 1px solid #ff4633;
        font-size: 22px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ff4633;
        padding: 0 5px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
    }
    &-right {
      font-size: 24px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
    }
  }
  .bottom {
    display: flex;
    justify-content: space-between;
    align-items: center;
    &-left-limit {
      font-size: 24px;
      font-family: PingFangSC-Regular, PingFang SC;
      color: #999;
    }
    &-left-money {
      font-size: 40px;
      font-family: DIN-Medium, DIN;
      font-weight: 500;
      color: #333333;
    }
    &-left-label {
      color: #999;
      font-size: 24px;
      font-family: PingFangSC-Regular, PingFang SC;
      p {
        color: #333;
        font-size: 24px;
        margin-top: 5px;
      }
    }
    .bottom-right {
      width: 170px;
      height: 60px;
      line-height: 60px;
      text-align: center;
      background: linear-gradient(90deg, #ff3333 0%, #ff5f34 100%);
      border-radius: 30px;
      font-size: 28px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #ffffff;
      height: 60px;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
  }
}
</style>
